<script setup>
import { useAuthStore } from '~/store/auth.js'

const authStore = useAuthStore()
const { user, isAdmin } = storeToRefs(authStore)

const config = useRuntimeConfig()
const homeLink = config.public.homeLink

const runtimeConfig = useRuntimeConfig()
const apiBase = runtimeConfig.public.apiBase

const commonLinks = [
  { path: `${homeLink}`, text: 'Aktuality' }
]

const adminLinks = [
  { path: '/concierge', text: 'Concierge' },
  { path: '/users', text: 'Uživatelé a jednotky' },
  { path: '/reservations', text: 'Rezervace' },
  { path: '/documents', text: 'Dokumenty' },
  { path: '/reservations/elevator-logs', text: 'Rezervace auto/motovýtahu' },
  { path: '/tests', text: 'Testování výtahů a dveří' }
]

const userLinks = [
  { path: '/reservations/new', text: 'Nová rezervace' },
  { path: '/reservations/bookings', text: 'Moje rezervace' },
  { path: '/reservations/elevator', text: 'Rezervace autovýtahu' },
  { path: '/mobile/chat', text: 'Chat' }
]

const localLinks = computed(() => {
  if (config.public.vercelEnv !== 'local') return []
  return [
    { path: `${apiBase}/admin/queues`, text: 'Bull board' }
  ]
})

const visibleLinks = computed(() => {
  const roleLinks = isAdmin.value ? adminLinks : userLinks
  return [...commonLinks, ...roleLinks]
})

onMounted(() => {
})

const onLogout = async (e) => {
  e.preventDefault()
  await authStore.clearAuthData()
  await navigateTo('/')
}

const breadcrumbs = getBreadcrumbs()
</script>

<template>
  <div class="sticky top-0 bg-tertiary">
    <div
      v-if="$config.public.vercelEnv !== 'production'"
      class="text-xs bg-red text-white text-center py-1"
    >
      {{ $config.public.vercelEnv.toUpperCase() }}
    </div>
    <header class="bg-white/50">
      <div class="w-full flex gap-16 items-center px-20">
        <!-- Logo -->
        <NuxtLink :to="{ path: '/news' }" class="block shrink-0">
          <img
            src="/logos/logo-text-primary.svg"
            alt="Vanguard Prague"
            class="logo"
          />
        </NuxtLink>

        <HeaderNav :items="visibleLinks" />

        <!-- Right side -->
        <div class="ml-auto flex items-center gap-4">
          <Button variant="outline" size="sm" to="/" @click="onLogout">
            Odhlásit se
          </Button>
          <UserAvatar :alt="user?.initials?.toUpperCase()" />
        </div>
      </div>
    </header>
    <Breadcrumbs :items="breadcrumbs" />
  </div>
</template>

<style scoped lang="postcss">
header {
  @apply w-full z-[1000];
}

.hamburger {
  @apply inline-block relative lg:hidden z-[600];
}

.user {
  @apply hidden flex-initial xs:flex items-center no-underline ml-25 md:ml-40 lg:ml-60 mr-25 md:mr-40 lg:mr-0;
}

.user .photo {
  @apply font-bold  w-[45px] h-[45px] leading-[45px] md:w-[55px] md:h-[55px] md:leading-[55px] bg-white rounded-full text-center mr-0 md:mr-[13px] text-black uppercase text-base overflow-hidden;
}

.user .photo img {
  @apply w-full h-full object-cover;
}

.user .name {
  @apply text-18 font-bold hidden md:inline-block;
}

.logo {
  @apply h-[30px] text-primary;
}
</style>
